import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import { commonKeyValues } from '../../../lib/utils'
import PrettyContactForm from '../pretty-contact-form'
import Popup from '../../popup'
import styles from './contactPopup.module.scss'

interface IContactPopupProps {
  onClose: () => void
}

const ContactPopup = ({ onClose }: IContactPopupProps) => (
  <Popup onClose={onClose}>
    <i
      className={styles.closeIcon}
      onClick={onClose}
      onKeyDown={(e) => e.keyCode === commonKeyValues.enter && onClose()}
      role="button"
      tabIndex={0}
    >
      <FontAwesomeIcon icon={faTimesCircle} />
    </i>
    <PrettyContactForm />
  </Popup>
)

export default ContactPopup
